import { Box, Portal, Stack } from '@mui/material';
import type { PropsWithChildren } from 'react';

export const cardActionPanelZIndex = 3000;

interface CardActionPanelProps extends PropsWithChildren {
  backgroundColor: string;
  onClose: () => void;
  onClick?: () => void;
}

export function CardActionPanel({
  backgroundColor,
  children,
  onClose,
  onClick,
}: CardActionPanelProps) {
  return (
    <Portal>
      <Box
        sx={{
          alignItems: 'center',
          bgcolor: 'rgba(0, 0, 0, 0.1)',
          display: 'flex',
          inset: 0,
          justifyContent: 'center',
          position: 'fixed',
          zIndex: cardActionPanelZIndex,
        }}
        onClick={onClick}
        onMouseDown={(event) => {
          if (event.target === event.currentTarget) {
            onClose();
          }
        }}
      >
        <Stack
          spacing={2}
          sx={{
            bgcolor: backgroundColor,
            boxShadow: '0 8px 24px rgba(16, 24, 40, 0.2)',
            maxHeight: 'calc(100dvh - 20px)',
            maxWidth: { xs: 'calc(100vw - 20px)', sm: 525 },
            overflowY: 'auto',
            p: 1.5,
            position: 'relative',
            width: '100%',
          }}
        >
          {children}
        </Stack>
      </Box>
    </Portal>
  );
}
